import { render, staticRenderFns } from "./PostPhotoGallery.vue?vue&type=template&id=6b2f5c32&"
import script from "./PostPhotoGallery.vue?vue&type=script&lang=js&"
export * from "./PostPhotoGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports